module.exports = __webpack_public_path__ + "static/img/bkg_icon.7096e8d8.png";